export const MFA_DASHBOARD_PAGE_MAIN_TITLE_ID = 'mfa-dashboard-page-main-title';
export const MFA_DASHBOARD_PAGE_OLDER_SESSIONS_LINK_ID = 'mfa-dashboard-page-older-sessions-link';
export const MFA_DASHBOARD_PAGE_TABLE_SECTION_ID = 'mfa-dashboard-page-table-section';
export const MFA_DASHBOARD_PAGE_SUMMARY_TITLE_ID = 'mfa-dashboard-page-usage-title';
export const MFA_DASHBOARD_PAGE_SUMMARY_SECTION_ID = 'mfa-dashboard-page-usage-section';
export const MFA_DASHBOARD_PAGE_FILTERS_SECTION_ID = 'mfa-dashboard-page-filters-section';

// Single Session Page
export const MFA_SESSION_HEADER_DAID = 'mfa-session-header';
export const MFA_SESSION_TITLE_DAID = 'mfa-session-title';
export const MFA_SESSION_COPY_URL_BUTTON_DAID = 'mfa-session-copy-url-button';
export const MFA_SESSION_OVERVIEW_TAB_DAID = 'mfa-session-overview-tab';
export const MFA_SESSION_ALL_ISSUES_TAB_DAID = 'mfa-session-all-issues-tab';
export const MFA_SESSION_SCANS_TAB_DAID = 'mfa-session-scans-tab';
export const MFA_SESSION_FILTERS_SECTION_ID = 'mfa-session-filters-section';
export const MFA_SESSION_ISSUES_TABLE_DAID = 'mfa-session-issues-table';
export const MFA_SESSION_SCANS_TABLE_DAID = 'mfa-session-scans-table';
export const MFA_SESSION_SCANS_SUMMARY_DAID = 'mfa-session-scans-summary';
export const MFA_SESSION_SCAN_CREATED_AT_DAID = 'mfa-session-scan-created-at';
export const MFA_SESSION_SCAN_SEVERITIES_GRAPH_DAID = 'mfa-session-scan-severities-graph';
export const MFA_SESSION_BREAKDOWN_BY_SEVERITY_PIE_CHART_DAID =
	'mfa-session-breakdown-by-severity-pie-chart';
export const MFA_SESSION_OVERVIEW_SUMMARY_DAID = 'mfa-session-overview-summary';
export const MFA_SESSION_TOP_ISSUE_TYPES_GRAPH_DAID = 'mfa-session-top-issue-types-graph';
export const MFA_TOTAL_ISSUES_BREAKDOWN_BY_ISSUE_TYPE_CHART_DAID =
	'mfa-total-issues-breakdown-by-issue-type-chart';
